<script setup lang="ts">
const benefits = [
  {
    title: 'Pengelolaan Data Terpusat',
    description:
      'Kelola dan analisis data pengiriman tanpa harus berpindah antar platform.',
    icon: 'material-symbols:save-outline',
    iconSize: '33px'
  },
  {
    title: 'Grafik Data Informatif',
    description:
      'Gali wawasan dari data pengiriman dengan grafik yang mudah dipahami.',
    icon: 'material-symbols:insert-chart-outline',
    iconSize: '33px'
  },
  {
    title: 'Data Akurat & Transparan',
    description:
      'Membantu menghasilkan keputusan bisnis yang lebih tepat sasaran.',
    icon: 'material-symbols:inventory',
    iconSize: '29px'
  }
]
</script>

<template>
  <section class="bg-surface-container-low">
    <UiContainer class="py-12 flex flex-col gap-6 lg:gap-16">
      <UiSectionTitle
        class="text-center"
        title="Keunggulan Laporan Pengiriman KiriminAja"
      />
      <div class="grid grid-cols-1 gap-6 lg:grid-cols-3">
        <UiCardFeature
          v-for="(benefit, index) in benefits"
          :key="index"
          :icon="benefit.icon"
          :icon-size="benefit.iconSize"
          :title="benefit.title"
          :description="benefit.description"
        />
      </div>

      <CtaBase />
    </UiContainer>
  </section>
</template>
